import { POLYGON_CHAIN_ID } from '@/constants/polymarket'
import { deriveSafe } from '@polymarket/builder-relayer-client/dist/builder/derive'
import { getContractConfig } from '@polymarket/builder-relayer-client/dist/config'

// Derive Safe address from EOA - pure function, no hooks needed
export function deriveSafeAddress(eoaAddress: string): `0x${string}` | undefined {
	try {
		const config = getContractConfig(POLYGON_CHAIN_ID)
		return deriveSafe(eoaAddress, config.SafeContracts.SafeFactory) as `0x${string}`
	} catch (err) {
		console.error('Error deriving Safe address:', err)
		return undefined
	}
}
